<template>
  <div class="legacy-entry">
    <header class="legacy-entry__banner">
      <img src="@/assets/img/legacy-systemverwaltung-banner.gif" alt="Systemverwaltung MANET Marketing GmbH" width="750" height="50" />
    </header>
    <div class="legacy-entry__divider" aria-hidden="true"></div>

    <div class="legacy-entry__page">
      <nav class="legacy-entry__nav" aria-label="Bereich">
        <span>» Termine</span><span class="legacy-entry__separator">|</span>
        <span>» Mobil</span><span class="legacy-entry__separator">|</span>
        <strong>Login</strong>
      </nav>

      <main class="legacy-entry__main">
        <section class="legacy-entry__message" aria-labelledby="legacy-entry-title">
          <div class="legacy-entry__notice">
            <h1 id="legacy-entry-title">Wir stellen auf unser neues Interface um!</h1>
            <p>
              Die Systemverwaltung von manetservice.de und mvtermine.de zieht in den neuen
              MANET Kundenbereich auf <strong>mein.mvp.de</strong> um.
            </p>
            <p>
              Dort können Sie sich mit Ihrer <strong>Kundennummer und Ihrem Passwort</strong> anmelden
              und Ihre Unterkünfte, Veranstaltungen und Inhalte verwalten.
            </p>
          </div>

          <div class="legacy-entry__next">
            <span class="legacy-entry__next-label">Ihr nächster Schritt</span>
            <h2>Weiter zum neuen Kundenbereich</h2>
            <p>Melden Sie sich mit Ihrer Kundennummer und Ihrem Passwort im neuen Bereich an.</p>
            <router-link class="legacy-entry__cta" :to="{name: 'login'}">
              Zum neuen Login <span aria-hidden="true">→</span>
            </router-link>
            <p class="legacy-entry__login-link">Noch kein Zugang? <router-link :to="{name: 'register'}">Konto erstellen</router-link></p>
          </div>

          <p class="legacy-entry__support">
            Bei Fragen oder Problemen hilft Ihnen unser Support:
            <a href="mailto:support@manet-marketing.de?subject=mein.mvp.de">support@manet-marketing.de</a>.
          </p>
        </section>
      </main>

      <footer class="legacy-entry__footer">&copy; by manet</footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Systemverwaltung',
}
</script>

<style scoped>
.legacy-entry {
  min-height: 100vh;
  background: #ffe5aa;
  color: #000031;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
}

.legacy-entry__banner {
  background: #f9cd8a;
  text-align: center;
}

.legacy-entry__banner img {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

.legacy-entry__divider {
  height: 3px;
  background: #fff;
}

.legacy-entry__page {
  width: min(100% - 24px, 750px);
  margin: 0 auto;
  background: #f9cd8a;
}

.legacy-entry__nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  min-height: 29px;
  padding: 4px 10px;
  font-size: 13px;
}

.legacy-entry__nav strong {
  color: #960018;
}

.legacy-entry__main {
  min-height: 380px;
  padding: 18px 15px 30px;
  border-top: 3px solid #ffe5aa;
  background: #ffe5aa;
}

.legacy-entry__message {
  max-width: 720px;
  margin: 0 auto;
}

.legacy-entry__notice {
  padding: 16px 18px;
  border: 1px solid #e9bb65;
  border-left: 5px solid #e0a42b;
  background: #fff5d7;
  line-height: 1.55;
}

.legacy-entry__notice h1 {
  margin: 0 0 12px;
  color: #664d03;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
}

.legacy-entry__notice p {
  margin: 0 0 10px;
}

.legacy-entry__notice p:last-child {
  margin-bottom: 0;
}

.legacy-entry__next {
  margin-top: 16px;
  padding: 20px 22px;
  border: 1px solid #b8d6e1;
  background: linear-gradient(110deg, #f5fbfd, #e4f1f5);
}

.legacy-entry__next-label {
  color: #1b6c97;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.legacy-entry__next h2 {
  margin: 8px 0;
  color: #0c3a53;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 19px;
  font-weight: bold;
  letter-spacing: 0;
}

.legacy-entry__next p {
  margin: 0 0 14px;
  line-height: 1.5;
}

.legacy-entry__cta {
  display: inline-flex;
  align-items: center;
  gap: 20px;
  min-height: 42px;
  padding: 10px 18px;
  background: #1b6c97;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
}

.legacy-entry__cta:hover, .legacy-entry__cta:focus-visible {
  background: #0c3a53;
  color: #fff;
}

.legacy-entry__next .legacy-entry__login-link {
  margin: 15px 0 0;
  font-size: 13px;
}

.legacy-entry__login-link a, .legacy-entry__support a {
  color: #08527a;
  font-weight: bold;
  text-decoration: underline;
}

.legacy-entry__support {
  margin: 20px 3px 0;
  line-height: 1.5;
}

.legacy-entry__footer {
  padding: 5px 10px;
  color: #960018;
  font-size: 12px;
  text-align: right;
}

@media (max-width: 600px) {
  .legacy-entry__main { padding: 14px 10px 25px; }
  .legacy-entry__next { padding: 17px; }
  .legacy-entry__cta { width: 100%; justify-content: space-between; }
}
</style>
